import { render, staticRenderFns } from "./Scrape.vue?vue&type=template&id=5c5a2ba2&scoped=true"
import script from "./Scrape.vue?vue&type=script&lang=js"
export * from "./Scrape.vue?vue&type=script&lang=js"
import style0 from "./Scrape.vue?vue&type=style&index=0&id=5c5a2ba2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a2ba2",
  null
  
)

export default component.exports